/**
 * Normalizes fee fields from checkout shipping-quote `order` payloads for express CreateOrder.
 *
 * @param {{ taxAmount?: number | string, deliveryFeeAmount?: number | string, tireDisposalFeeAmount?: number | string }} order
 * @returns {{ taxAmount: number | string, deliveryFee: number | string, tireDisposalFee: number | string }}
 */
export function resolveExpressOrderFeesFromShippingQuote(order) {
	return {
		taxAmount: order.taxAmount,
		deliveryFee: order.deliveryFeeAmount ? order.deliveryFeeAmount : 0,
		tireDisposalFee: order.tireDisposalFeeAmount ? order.tireDisposalFeeAmount : 0,
	};
}

/**
 * @param {Array<{ type: string, label: string, amount: number | string }>} lineItems
 * @param {{ deliveryFeeAmount?: number | string, tireDisposalFeeAmount?: number | string }} order
 * @param {string} state
 */
export function appendApplePayFeeLineItemsFromShippingQuote(lineItems, order, state) {
	if (order.deliveryFeeAmount) {
		lineItems.push({
			type: 'final',
			label: state === 'MN' ? 'Road Improvement and Food Delivery Fee' : 'Retail Delivery Fee',
			amount: order.deliveryFeeAmount,
		});
	}

	if (order.tireDisposalFeeAmount) {
		lineItems.push({
			type: 'final',
			label: 'State Tire Fee',
			amount: order.tireDisposalFeeAmount,
		});
	}
}

/**
 * @param {{ deliveryFeeAmount?: number | string, tireDisposalFeeAmount?: number | string }} order
 * @param {string} state
 * @returns {{
 *   displayItems: Array<{ type: string, label: string, price: string, status: string }>,
 *   deliveryFee: number | string,
 *   tireDisposalFee: number | string,
 * }}
 */
export function buildGooglePayFeeDisplayItems(order, state) {
	const displayItems = [];
	let deliveryFee = 0;
	let tireDisposalFee = 0;

	if (order.deliveryFeeAmount) {
		displayItems.push({
			type: 'LINE_ITEM',
			label: state === 'MN' ? 'Road Improvement and Food Delivery Fee' : 'Retail Delivery Fee',
			price: `${order.deliveryFeeAmount}`,
			status: 'FINAL',
		});
		deliveryFee = order.deliveryFeeAmount;
	}

	if (order.tireDisposalFeeAmount) {
		displayItems.push({
			type: 'LINE_ITEM',
			label: 'State Tire Fee',
			price: `${order.tireDisposalFeeAmount}`,
			status: 'FINAL',
		});
		tireDisposalFee = order.tireDisposalFeeAmount;
	}

	return { displayItems, deliveryFee, tireDisposalFee };
}
